import React, { CSSProperties, ReactElement } from 'react'
import { Dropdown } from 'antd'
import { Icon, IconType } from '@lmc/ui-kit'
import { colors } from '@lmc/common/constants'

type Props = {
  localisation?: {
    unsigned: string
  }
  popOver?: ReactElement
  state?: 'signed' | 'unsigned' | 'archived' | 'refused'
}

const ListItemRightChildren = ({ localisation, popOver, state }: Props) => {
  switch (state) {
    case 'archived':
      return (
        <Icon
          customIcon={IconType.Other}
          style={{ ...styles.otherIcon, ...styles.archived } as CSSProperties}
        />
      )
    case 'unsigned':
      return (
        <div style={styles.container}>
          <div style={styles.unAssigned}>{localisation?.unsigned}</div>
          <Icon
            customIcon={IconType.Incidents}
            style={{ float: 'right', cursor: 'pointer', marginLeft: 5 }}
          />{' '}
          <div onClick={(e) => e.stopPropagation()}>
            <Dropdown
              overlay={<div>{popOver}</div>}
              placement="bottomRight"
              trigger={['click']}
            >
              <Icon
                customIcon={IconType.Other}
                style={styles.otherIcon as CSSProperties}
              />
            </Dropdown>
          </div>
        </div>
      )
    default:
      return (
        <div onClick={(e) => e.stopPropagation()}>
          <Dropdown
            overlay={<div>{popOver}</div>}
            placement="bottomRight"
            trigger={['click']}
          >
            <Icon
              customIcon={IconType.Other}
              style={styles.otherIcon as CSSProperties}
            />
          </Dropdown>
        </div>
      )
  }
}

const styles = {
  archived: {
    cursor: 'default',
  },
  button: {
    borderRadius: 0,
  },
  container: {
    display: 'flex',
  },
  menu: {
    borderRadius: 4,
    boxShadow:
      '0 1px 3px hsla(0, 0%, 0%, 0.05), 0 2px 4px hsla(0,0%,0%,0.05), 0 -1px 3px hsla(0, 0%, 0%, 0.05), 0 -2px 4px hsla(0,0%,0%,0.05)',
    minWidth: 120,
  },
  menuItem: {
    margin: 0,
    padding: 0,
  },
  otherIcon: {
    float: 'right',
    cursor: 'pointer',
    marginLeft: 16,
    width: 20,
    height: 20,
  },
  unAssigned: {
    color: colors.red,
    marginLeft: 'auto',
    marginRight: '0',
    fontSize: 12,
  },
}

export default ListItemRightChildren
